import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './MainNavbar.css';

const MainNavbar = () => {
  const location = useLocation();

  return (
    <nav className="main-navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <h2>NN</h2>
        </div>
        
        {/* Regular menu for desktop */}
        <div className="navbar-menu-desktop">
          <Link
            to="/"
            className={`nav-link${location.pathname === '/' ? ' active' : ''}`}
          >
            Portfolio
          </Link>
          <Link
            to="/blog"
            className={`nav-link${location.pathname === '/blog' ? ' active' : ''}`}
          >
            Blog
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default MainNavbar;
